import map from 'lodash/map';
import React, {Component} from 'react';
// import {connect} from '~/redux/connect';
import { connect } from '~/redux/connect';
import {getLoadedModels, isAuthenticated} from "~/stateGetter";
import ModelManager from './ModelManager';
import ModConfigCache from "~/ui/ModelDataManager/ModConfigCache";
import { Box } from "~/native-ui";

export class ModelTreeDataManager extends Component {
    static propTypes = {};

    render() {
        let { modelIds } = this.props;

        let managers = map(modelIds, (modelId ) => <ModelManager modelId={modelId} key={modelId} />);
        
        return <Box display="none">
            {managers}
        </Box>;
    }
}

const RXModelTreeDataManager = connect(
    (state) => {
        let loadedModels = getLoadedModels(state);
        // console.log('-----------------------------------CHANGED');
        // console.log('CHANGED A', state.lastAction.type, map(loadedModels, 'modelId'));

        return {
            modelIds: map(loadedModels, 'modelId'),
        }
    },
    (dispatch) => ({})
)(ModelTreeDataManager);

export default RXModelTreeDataManager;